import rollcall from "@/language/modules/page/my/easy/leader/shepherd/rollcall/zhCN"

export default {
    nav: {
        subject: "牧养族群"
    },
    edit: {
        nav: {
            subject: "所属族群"
        },
        rollcall: rollcall
    }
}
